import React, { useState, useCallback } from 'react'

import { NewLocation } from '.'
import ConfirmCancelButtons from 'components/Buttons/ConfirmCancelButtons'
import {
	Container,
	Header,
	StreetAddressInput,
	InputRow,
	ProvinceInput,
	ZipCodeInput,
	UnitInput,
	PhoneInput,
	HorizontalSeparator,
} from './AddOfficeLocation.styles'

interface AddOfficeLocationProps {
	onAdd: (location: NewLocation) => any,
	onCancel: () => any,
}

export default function AddOfficeLocation(
	{
		onAdd,
		onCancel,
	}: AddOfficeLocationProps,
) {

	const [location, setLocation] = useState({
		streetAddress: '',
		province: '',
		zipCode: '',
		unit: '',
		email: '',
	} as NewLocation)
	const editLocation = useCallback((newState: any) => {
		setLocation({
			...location,
			...newState,
		})
	}, [location, setLocation])

	return (
		<Container>
			<Header>
				Add Office Location
			</Header>
			<p className='info'>
				Enter the address of your new office location.
			</p>
			<StreetAddressInput
				placeholder={'Street Address'}
				onChange={({ target }) => {
					editLocation({ streetAddress: target.value })
				}}
			/>
			<InputRow>
				<ProvinceInput
					placeholder={'Province / Territory'}
					onChange={({ target }) => {
						editLocation({ province: target.value })
					}}
				/>
				<ZipCodeInput
					placeholder={'Postal/ZIP Code'}
					onChange={({ target }) => {
						editLocation({ zipCode: target.value })
					}}
				/>
			</InputRow>
			<InputRow>
				<UnitInput
					placeholder={'Unit #'}
					onChange={({ target }) => {
						editLocation({ unit: target.value })
					}}
				/>
				<PhoneInput
					placeholder={'Email'}
					onChange={({ target }) => {
						editLocation({ email: target.value })
					}}
				/>
			</InputRow>
			<HorizontalSeparator />
			<ConfirmCancelButtons
				confirmText={'Add'}
				onConfirm={() => onAdd(location)}
				cancelText={'Cancel'}
				onCancel={onCancel}
			/>
		</Container>
	)
}
